import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Grooming from './pages/Grooming';
import Products from './pages/Products';
import Prices from './pages/Prices';
import GalleryPage from './pages/GalleryPage';
import Contact from './pages/Contact';
import About from './pages/About';
import SaunaRental from './pages/SaunaRental';

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="om-salonen" element={<About />} />
          <Route path="klipning" element={<Grooming />} />
          <Route path="sauna-udlejning" element={<SaunaRental />} />
          <Route path="produkter" element={<Products />} />
          <Route path="priser" element={<Prices />} />
          <Route path="galleri" element={<GalleryPage />} />
          <Route path="kontakt" element={<Contact />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}

export default App;
